import { useWatch } from 'react-hook-form';
import { useFieldContext } from '../FieldContext';
import { EmptyField } from './EmptyField';
import { FieldControlBase } from './FieldControlBase';
import type { FieldComponentProps } from './fieldComponent.types';
import { LegacyMeasurementInput } from './LegacyMeasurementInput';

/**
 * Legacy MEASUREMENT custom field (legacy `MEASUREMENT.jsx` /
 * `MeasurementInput`): a free amount with a unit picked from the length,
 * area and mass lists. The newer `measurement` kind converts units; this one
 * stores the amount as typed.
 */
export function MeasurementLegacyField({
  spec,
  path,
  hideLabel
}: FieldComponentProps<'measurement-legacy'>) {
  const ctx = useFieldContext();
  const amount: number | null = useWatch({ name: `${path}.amount` }) ?? null;

  // A unit alone is no value (the codec's `isEmpty` agrees).
  if (ctx.mode === 'display' && amount === null) {
    return <EmptyField spec={spec} path={path} hideLabel={hideLabel} />;
  }

  return (
    <FieldControlBase spec={spec} hideLabel={hideLabel} path={path}>
      <LegacyMeasurementInput
        path={path}
        label={spec.label}
        required={spec.required}
        units={spec.units}
        placeholder="Enter value"
      />
    </FieldControlBase>
  );
}
